import { httpsCallable } from 'firebase/functions';
import { functions } from './config';

const loadImagesFunction = httpsCallable(functions, 'loadImages');
const loadImagesDeviceFunction = httpsCallable(functions, 'loadImagesDevice');
const loadCalendarImage = httpsCallable(functions, 'loadCalendarImage');
const getImageURL = httpsCallable(functions, 'getImageURL');
const deleteImagesFunction = httpsCallable(functions, 'deleteImages');
const listAssignedResidentsFunction = httpsCallable(
  functions,
  'listAssignedResidents',
);
const getPossibleResidentsFunction = httpsCallable(
  functions,
  'getPossibleResidents',
);

const getPossibleRoomsFunction = httpsCallable(functions, 'getPossibleRooms');

const sendSms = httpsCallable(functions, 'sendSms');
const sendNotification = httpsCallable(functions, 'sendNotification');
const generateSignedUrl = httpsCallable(functions, 'generateSignedUrl');

export {
  loadImagesFunction,
  loadImagesDeviceFunction,
  loadCalendarImage,
  deleteImagesFunction,
  listAssignedResidentsFunction,
  getPossibleResidentsFunction,
  sendSms,
  sendNotification,
  getImageURL,
  generateSignedUrl,
  getPossibleRoomsFunction,
};
